import {addQueryToPath} from '../../../libs/shared/core/src/helpers/browser/urlHelpers';
import {CompanyModel} from '../../../libs/shared/core/src/models/api/company/companyModel';
import {fetchApiAsync} from '../../../libs/shared/core/src/services/http/http';
import {ApiAnalyticsAccounts} from '../../models/api/analyticsAccountModel';

export async function fetchAccounts(company: CompanyModel, accountIds: ReadonlyArray<number>) {
  return fetchApiAsync(
    ApiAnalyticsAccounts,
    addQueryToPath(`${company.url}/anltcs/accounts`, {account_ids: accountIds.join(',')}),
  );
}
